import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../../common/utils/froala.utils';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CasingTubing, EditedCasingTubingRecord } from '../../../common/models/well.model';
import { CasingTypeModel, DrillingEquipmentModel } from "../../../form-controls/components/new-casing-plan/models/casing-plan.model";

@Component({
    selector: 'edit-casing-tubing-record',
    templateUrl: './edit-casing-tubing-record.component.html',
    styleUrls: ['./edit-casing-tubing-record.component.scss'],
    standalone: false
})
export class EditCasingTubingRecordComponent implements OnInit {

	@Input() casingTypes: CasingTypeModel[] = [];

	private editorKey: string;
	private _froalaOptions: any = null;

	form: FormGroup;

	get froalaOptions(): any {
		if (!this._froalaOptions) {
			this._froalaOptions = applyFroalaAriaFix({
				heightMax: 300,
				heightMin: 300,
				key: this.editorKey,
				saveInterval: 0,
				toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough'],
				typingTimer: 150
			});
		}
		return this._froalaOptions;
	}

	@Output() recordEdited: EventEmitter<EditedCasingTubingRecord> = new EventEmitter<EditedCasingTubingRecord>();
	showModal: boolean = false;

	@Input() tools: DrillingEquipmentModel[] = [];

	constructor(private builder: FormBuilder) {
		let conf = window["PdfConfig"] as any;
		this.editorKey = (conf != null) ? conf.editorLicenseKey : "";
	}

	ngOnInit() {
	}

	buildForm(record: EditedCasingTubingRecord): void {
		let comments: string = record.comments != null
			? record.comments
			: "";
		this.form = this.builder.group({
			id: [{ value: record.id, disabled: true }, []],
			type: [{ value: record.type, disabled: true }, []],
			wellboreDiameter: [{ value: record.wellboreDiameter, disabled: false }, []],
			casingDiameter: [{ value: record.casingDiameter, disabled: false }, []],
			collarDiameter: [{ value: record.collarDiameter, disabled: false }, []],
			feetInstalled: [{ value: record.feetInstalled, disabled: false }, []],
			feetLeftInWell: [{ value: record.feetLeftInWell, disabled: false }, []],
			cementVolume: [{ value: record.cementVolume, disabled: false }, []],
			cementTop: [{ value: record.cementTop, disabled: false }, []],
			grade: [{ value: record.grade, disabled: false }, []],
			weight: [{ value: record.weight, disabled: false }, []],
			burstPressureRating: [{ value: record.burstPressureRating, disabled: false }, []],
			bottom: [{ value: record.bottom, disabled: false }, []],
			isFinal: [{ value: record.isFinal, disabled: false }, []],
			toolType: [{ value: record.toolType, disabled: false }, []],
			comments: [{ value: comments, disabled: false }, [Validators.required]]
		});
	}

	close(): void {
		this.form = null;
		this.showModal = false;
	}

	getCasingType(type: string): string {
		let description: string = type;
		let casing = this.casingTypes.find(c => c.code === type);
		if (casing != null) {
			if (casing.definition.endsWith("Casing")) {
				let index = casing.definition.indexOf("Casing");
				description = casing.definition.substring(0, index);
			} else if (casing.definition.endsWith("1") || casing.definition.endsWith("2")) {
				description = casing.definition.substring(0, casing.definition.length - 2);
			} else {
				description = casing.definition;
			}
		}
		return description;
	}


	openForm(record: EditedCasingTubingRecord): void {
		console.log('record in editor', record);
		this.buildForm(record);
		this.showModal = true;
	}

	save(): void {
		let edit: EditedCasingTubingRecord = new EditedCasingTubingRecord();
		edit.id = this.form.get('id').value;
		edit.type = this.form.get('type').value;
		edit.wellboreDiameter = this.form.get('wellboreDiameter').value;
		edit.casingDiameter = this.form.get('casingDiameter').value;
		edit.collarDiameter = this.form.get('collarDiameter').value;
		edit.feetInstalled = this.form.get('feetInstalled').value;
		edit.feetLeftInWell = this.form.get('feetLeftInWell').value;
		edit.cementVolume = this.form.get('cementVolume').value;
		edit.cementTop = this.form.get('cementTop').value;
		edit.grade = this.form.get('grade').value;
		edit.weight = this.form.get('weight').value;
		edit.burstPressureRating = this.form.get('burstPressureRating').value;
		edit.toolType = this.form.get('toolType').value;
		edit.bottom = this.form.get('bottom').value;
		edit.isFinal = this.form.get('isFinal').value;
		edit.comments = stripFroalaWatermark(this.form.get('comments').value);
		this.recordEdited.emit(edit);
		this.close();
	}
}
